import styled from "styled-components";

// TEXT

// STYLES
export const Icon = styled.svg`
  height: 1.25rem;
`;

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
